import { render, staticRenderFns } from "./CreateCollectorModal.vue?vue&type=template&id=35d0aa38&"
import script from "./CreateCollectorModal.vue?vue&type=script&lang=js&"
export * from "./CreateCollectorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports